import { Project, RunningTimer } from "~/lib";
import { useFetcher } from "@remix-run/react";
import { Duration } from "luxon";
import { StartTimerParams } from "~/routes/api.projects.$projectId.start/route";
import { createFormData } from "~/lib/form-parse";

export default function ({
  project,
  runningTimer,
}: {
  project: Project;
  runningTimer?: RunningTimer;
}) {
  const deleteFetcher = useFetcher();
  const startFetcher = useFetcher();

  const todayFormattedTime = Duration.fromMillis(
    project.trackedTime * 1000,
  ).toFormat("h:mm:ss");

  const weekFormattedTime = Duration.fromMillis(
    project.weeklyTrackedTime * 1000,
  ).toFormat("h:mm:ss");

  const deleteAction = () => {
    if (confirm("Are you sure you want to delete?")) {
      deleteFetcher.submit(null, {
        method: "post",
        action: `/api/projects/${project.id}/delete`,
      });
    }
  };

  const startAction = () => {
    const formData = createFormData<StartTimerParams>({
      completeCurrentTimer: true,
      timerStartTime: undefined,
    });

    startFetcher.submit(formData, {
      method: "post",
      action: `/api/projects/${project.id}/start`,
    });
  };

  const copyIdAction = async () => {
    await navigator.clipboard.writeText(project.id);
  };

  return (
    <div className="project-container">
      <p>{project.name}</p>
      <p>Today: {todayFormattedTime}</p>
      <p>Last week: {weekFormattedTime}</p>
      <button onClick={copyIdAction}>Copy id</button>
      <button onClick={deleteAction}>Delete</button>
      <button
        onClick={startAction}
        disabled={
          startFetcher.state === "loading" ||
          runningTimer?.projectId === project.id
        }
      >
        Start
      </button>
    </div>
  );
}
